import React from "react";
import DeviseHeader from "./DeviseHeader";
const DeviseContainer = ({ children, subtitle, title }) => { return /*#__PURE__*/ React.createElement("div", { className: "auth" }, /*#__PURE__*/ React.createElement(DeviseHeader, null), /*#__PURE__*/ React.createElement("h1", { className: "auth__title" }, title), /*#__PURE__*/ React.createElement("p", { className: "auth__subtitle" }, subtitle), children); };
export default DeviseContainer;
